import React from 'react';
import { Button, Dialog, DialogTitle, MenuItem } from '@mui/material';
import { SimpleForm, Toolbar, required, useRecordContext } from 'react-admin';
import useDialog from 'hooks/useDialog';
import { ApplicationStatus, ApprovedStatus } from '../ApplicationStatusControl';
import AdministratorInput from 'components/Filter/AdministratorInput';
import { ENUMS } from 'components/Enum/enums';
import { useFormContext } from 'react-hook-form';

enum ApproveLabel {
  resume_review = 'Approve (Written Screen)',
  phone_screen_pending = 'Approve (Written Screen)',
}
enum ApproveConfirmationLabel {
  resume_review = 'Approve as Written Screen?',
  phone_screen_pending = 'Approve as Written Screen?',
}

interface ApproveItemProps {
  currentApplicationStatus: ApplicationStatus;
  updateApplicationStatus: (val: any) => void;
}

const ApproveItem = ({ currentApplicationStatus, updateApplicationStatus }: ApproveItemProps) => {
  const { open, closeDialog, openDialog } = useDialog();
  return (
    <>
      <MenuItem onClick={openDialog}>
        {ApproveLabel[currentApplicationStatus] ?? 'Approve'}
      </MenuItem>
      <ApproveDialog
        open={open}
        closeDialog={closeDialog}
        updateApplicationStatus={updateApplicationStatus}
        currentApplicationStatus={currentApplicationStatus}
      />
    </>
  );
};

const ApproveToolBar = ({ closeDialog }) => {
  const { getValues } = useFormContext();
  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button onClick={closeDialog}>Cancel</Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={!getValues().screener_account_id}
      >
        Submit
      </Button>
    </Toolbar>
  );
};

const ApproveDialog = ({
  open,
  closeDialog,
  updateApplicationStatus,
  currentApplicationStatus,
}) => {
  const record = useRecordContext();
  const submitApprove = ({ screener_account_id }: any) => {
    updateApplicationStatus({
      professional_id: record?.id,
      screener_account_id,
      application_status: ApprovedStatus,
      reason: 'application',
      screening_type: 'written',
    });
  };

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>
        {ApproveConfirmationLabel[currentApplicationStatus] ?? 'Approve application?'}
      </DialogTitle>
      <SimpleForm onSubmit={submitApprove} toolbar={<ApproveToolBar closeDialog={closeDialog} />}>
        <AdministratorInput
          source="screener_account_id"
          label="Screening Recruiter"
          validate={required()}
          filter={{
            permission_group_roles: [ENUMS.PermissionGroup.role.support_agent],
          }}
          alwaysOn
          emptyText="Clear"
          optionValue="account.id"
        />
      </SimpleForm>
    </Dialog>
  );
};

export default ApproveItem;
